'use strict';

var React = require('react');

var SvgRows2Major = function SvgRows2Major(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2 20a2 2 0 0 1-2-2v-16a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2h-16Zm0-11v-7h16v7h-16Zm0 2v7h16v-7h-16Z"
  }));
};

exports.SvgRows2Major = SvgRows2Major;
